import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('public.hard-token-login', {
        url: '/hardtokenlogin?client&code&continue&domain&redirect&type',
        templateUrl: require('./hard-token-login.html'),
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/public/hard-token-login/hard-token-login.state.js